export function loginFeedback(remaining, seconds, danish) {
  if (seconds > 0) return danish ? `Du kan prøve at logge ind igen om ${seconds} ${seconds===1?'sekund':'sekunder'}.` : `You can try signing in again in ${seconds} ${seconds===1?'second':'seconds'}.`;
  if (Number.isInteger(remaining) && remaining > 0 && remaining < 10) return danish
    ? `E-mail eller kodeord er forkert. Du har ${remaining} forsøg tilbage før en pause på højst 60 sekunder.`
    : `The email or password is incorrect. You have ${remaining} ${remaining === 1 ? 'attempt' : 'attempts'} left before a pause of up to 60 seconds.`;
  if (remaining === 0) return danish ? 'Du kan prøve at logge ind igen nu.' : 'You can try signing in again now.';
  return null;
}
